import { useState } from 'react';
import { useQuery } from '@apollo/client';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import { baseVars } from 'graph/apollo-util';
import GET_ORGANIZATION_ENGAGEMENT_CURRICULUM_REPORT from 'graph/reports/get-organization-engagement-curriculum-report';
import { PrmOrganizationEngagementCurriculumReportResult } from 'types/schema-generated-types';

const useDistrictEngagement = () => {
  const [productCurriculumId, setProductCurriculumId] = useState<any>(null);
  const [{ entityId }] = useReportQueryParams();
  const { data, loading } = useQuery<{
    prmOrganizationEngagementCurriculumReport: PrmOrganizationEngagementCurriculumReportResult;
  }>(GET_ORGANIZATION_ENGAGEMENT_CURRICULUM_REPORT, {
    ...baseVars({ organizationId: entityId, productCurriculumId: productCurriculumId }),
    skip: !productCurriculumId
  });

  const organizationCurriculumProgress =
    data?.prmOrganizationEngagementCurriculumReport?.organizationCurriculumProgress;

  return [
    { organizationCurriculumProgress, productCurriculumId, loading },
    {
      setProductCurriculumId
    }
  ];
};

export default useDistrictEngagement;
